import { Box, Button, Typography } from "@mui/material";

function CustomNoRowsOverlay({ onImportClick }) {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        padding: 4,
        pt: {
          xs: 20,
          md: 30,
        },
        color: "text.secondary",
      }}
    >
      <Typography variant="body1" gutterBottom>
        Search and Add Items in the Search Bar Above
      </Typography>
      <Typography variant="body1" gutterBottom>
        Or
      </Typography>
      <Typography variant="body1" gutterBottom>
        Import from the Quote You Saved
      </Typography>
      <Button variant="outlined" color="error" onClick={onImportClick}>
        Import
      </Button>
    </Box>
  );
}

export default CustomNoRowsOverlay;
